(function(){
    function init(){
      var dataElement=document.getElementById('HeilargProductInformationData');
      if(!dataElement)return;
      var data=JSON.parse(dataElement.textContent);
      var main=document.querySelector('product-form[data-main="true"]');
      if(!main||main.dataset.informationReady)return;
      main.dataset.informationReady='true';
      var root=main.closest('.shopify-section')||document.getElementById('MainContent');
      if(data.singleVariant)root.classList.add('hl-single-variant');
      var source=main.querySelector('form');
      var template=document.getElementById('HeilargOrderTotalTemplate');
      var buttons=main.querySelector('.product-form__buttons');
      if(!source||!template||!buttons)return;
      var fragment=template.content.cloneNode(true);
      var total=fragment.querySelector('.hl-order-total');
      buttons.prepend(fragment);
      var output=total.querySelector('.hl-order-total__amount');
      var lastPrimaryVariantId=null;
      function carryPrimaryChoice(breaks,activeCard,id){
        if(!breaks||breaks.dataset.optionPlacement!=='before_bundle'||lastPrimaryVariantId===id)return;
        lastPrimaryVariantId=id;
        var variant=data.variants.find(function(item){return String(item.id)===id});
        if(!variant)return;
        var values=variant.options||[variant.option1,variant.option2,variant.option3];
        breaks.querySelectorAll('label[data-quantity]').forEach(function(card){
          if(card===activeCard)return;
          card.querySelectorAll('.quantity-break__selector-item').forEach(function(picker){
            picker.querySelectorAll('select.quantity-break__variant-select').forEach(function(select,index){
              var value=values[index];
              if(value&&select.value!==value){
                select.value=value;
                select.dispatchEvent(new Event('change',{bubbles:true}));
              }
            });
          });
        });
      }
      var prices=new Map(data.variants.map(function(variant){return[String(variant.id),variant.price]}));
      var comparePrices=new Map(data.variants.map(function(variant){return[String(variant.id),Math.max(variant.price,variant.compare_at_price||0)]}));
      function money(cents){
        var format=data.moneyFormat||'';
        var token=format.match(/\{\{\s*(\w+)\s*\}\}/);
        var kind=token?token[1]:'amount';
        var decimals=kind.indexOf('no_decimals')<0?2:0;
        var separator=kind.indexOf('comma_separator')>=0?',':'.';
        var thousands=separator===','?'.':',';
        if(kind.indexOf('space')>=0)thousands=' ';
        if(kind.indexOf('apostrophe')>=0)thousands="'";
        var parts=(cents/100).toFixed(decimals).split('.');
        parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,thousands);
        var number=parts.join(separator);
        var formatted=token?format.replace(token[0],number):number;
        var decoder=document.createElement('div');
        decoder.innerHTML=formatted;
        return decoder.textContent;
      }
      var galleryVariantId=null;
      function syncVariantGallery(variant,section){
        if(data.galleryGrouping!=='option1')return;
        var selected=String(variant.option1||(variant.options||[])[0]||variant.title).toLowerCase();
        var values=data.variants.map(function(item){return String(item.option1||(item.options||[])[0]||item.title).toLowerCase()});
        var galleries=root.querySelectorAll('media-gallery');
        var ready=false;
        galleries.forEach(function(gallery){
          if(typeof gallery.setActiveMedia!=='function')return;
          if(gallery.dataset.heilargDesignVariant===String(variant.id)){ready=true;return;}
          var slides=Array.from(gallery.querySelectorAll('.product__media-item'));
          var dots=gallery.querySelectorAll('.slider-counter__link');
          dots.forEach(function(dot,index){if(slides[index])dot.dataset.alt=slides[index].dataset.alt||'';});
          gallery.filteringOption='option1';
          gallery.dataset.optionValues=JSON.stringify(values);
          gallery.dataset.disablePrepend='true';
          gallery.prependMedia=false;
          var active=slides.find(function(slide){return String(slide.dataset.alt||'').toLowerCase().includes(selected)});
          if(!active)return;
          gallery.setActiveMedia(active.dataset.mediaId,false,true,{option1:selected});
          gallery.dataset.heilargDesignVariant=String(variant.id);
          ready=true;
        });
        if(ready)galleryVariantId=String(variant.id);
        else if(window.customElements&&window.customElements.get('media-gallery')===undefined){
          window.customElements.whenDefined('media-gallery').then(schedule);
        }
      }
      function syncVariantDesignDisplay(id){
        var variant=data.variants.find(function(item){return String(item.id)===String(id)});
        if(!variant)return;
        var section=main.dataset.section;
        var primary=document.getElementById('price-'+section);
        var sticky=document.getElementById('sticky-atc-'+section);
        [primary,sticky].forEach(function(container){
          if(!container)return;
          var onSale=Number(variant.compare_at_price||0)>variant.price;
          container.querySelectorAll('.price').forEach(function(node){node.classList.toggle('price--on-sale',onSale);});
          container.querySelectorAll('.price-item--regular,.price-item--sale').forEach(function(node){
            var isCompare=node.matches('.price__sale .price-item--regular,.price__compare .price-item--regular');
            var value=money(isCompare&&onSale?variant.compare_at_price:variant.price);
            if(node.textContent.trim()!==value)node.textContent=value;
          });
        });
        var image=document.getElementById('sticky-atc-image-'+section);
        var photo=variant.featured_image;
        if(image&&photo&&photo.src&&image.getAttribute('src')!==photo.src){
          image.setAttribute('src',photo.src);
          image.removeAttribute('srcset');
          image.setAttribute('alt',photo.alt||variant.title+' design');
        }
        syncVariantGallery(variant,section);
      }
      function calculate(){
        var breaks=document.getElementById('quantity-breaks-'+main.dataset.section);
        var selected=breaks&&breaks.querySelector('input[type="radio"][name="quantity"]:checked');
        var label=selected&&selected.nextElementSibling;
        var pickers=label?Array.from(label.querySelectorAll('[data-selected-id]')):[];
        var idInput=source.querySelector('[name="id"]');
        if(!idInput)return;
        if(breaks)breaks.querySelectorAll('label[data-quantity]').forEach(function(card){
          var cardIds=Array.from(card.querySelectorAll('[data-selected-id]')).map(function(picker){return picker.dataset.selectedId});
          if(!cardIds.length)for(var n=0;n<Number(card.dataset.quantity||1);n++)cardIds.push(idInput.value);
          var discount=Math.round((1-Number(card.dataset.percentageLeft||1))*100);
          var regular=0,discounted=0;
          for(var cardId of cardIds){
            var unitPrice=prices.get(String(cardId));
            if(typeof unitPrice!=='number')return;
            regular+=unitPrice;
            discounted+=unitPrice-Math.floor(unitPrice*discount/100);
          }
          discounted=Math.max(0,discounted-Math.round(Number(card.dataset.fixedDiscount||0)));
          var priceNode=card.querySelector('.quantity-break__price[data-text="[price]"]');
          if(priceNode&&priceNode.textContent.trim()!==money(discounted))priceNode.textContent=money(discounted);
          if(breaks.classList.contains('hl-bundle')){
            var compareTotal=regular;
            if(card.dataset.bundleCompareMode==='compare_price')compareTotal=cardIds.reduce(function(sum,id){return sum+(comparePrices.get(String(id))||0)},0);
            var compareNode=card.querySelector('.quantity-break__compare-price[data-text="[compare_price]"]');
            if(compareNode){
              if(compareNode.textContent.trim()!==money(compareTotal))compareNode.textContent=money(compareTotal);
              compareNode.classList.toggle('hidden',compareTotal<=discounted);
            }
          }
          var caption=card.querySelector('.quantity-break__caption[data-text]');
          if(caption&&caption.dataset.text.indexOf('[amount_saved]')>=0){
            var captionText=caption.dataset.text.replace('[amount_saved]',money(regular-discounted));
            if(caption.textContent.trim()!==captionText)caption.textContent=captionText;
          }
        });
        var ids=[];
        if(pickers.length)ids=pickers.map(function(picker){return picker.dataset.selectedId});
        else{
          var quantity=Number(selected?selected.value:(source.elements.namedItem('quantity')||{}).value)||1;
          for(var i=0;i<quantity;i++)ids.push(idInput.value);
        }
        if(ids.length){
          var firstId=String(ids[0]);
          carryPrimaryChoice(breaks,label,firstId);
          if(idInput.value!==firstId){
            idInput.value=firstId;
            idInput.setAttribute('value',firstId);
            idInput.dispatchEvent(new Event('change',{bubbles:true}));
          }
          syncVariantDesignDisplay(firstId);
        }
        var percentageOff=label?Math.round((1-Number(label.dataset.percentageLeft||1))*100):0;
        var fixedDiscount=label?Math.round(Number(label.dataset.fixedDiscount||0)):0;
        var subtotal=0;
        for(var index=0;index<ids.length;index++){
          var price=prices.get(String(ids[index]));
          if(typeof price!=='number'){total.hidden=true;return}
          subtotal+=price-Math.floor(price*percentageOff/100);
        }
        subtotal=Math.max(0,subtotal-fixedDiscount);
        var extras=new Set();
        document.querySelectorAll('.sp-extra__cb:checked[data-variant]').forEach(function(input){extras.add(input.dataset.variant)});
        for(var extra of extras){
          if(typeof data.extras[extra]!=='number'){total.hidden=true;return}
          subtotal+=data.extras[extra];
        }
        total.hidden=false;
        output.textContent=money(subtotal);
      }
      var timer;
      function schedule(){clearTimeout(timer);timer=setTimeout(calculate,0)}
      document.addEventListener('change',schedule,true);
      document.addEventListener('input',schedule,true);
      document.addEventListener('click',schedule,true);
      new MutationObserver(function(records){
        if(records.some(function(record){return !total.contains(record.target)}))schedule();
      }).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['value','data-selected-id','checked']});
      calculate();
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
    document.addEventListener('shopify:section:load',init);
  })();